import { render, staticRenderFns } from "./ScreeningPendingCreatives.vue?vue&type=template&id=520d6c90"
import script from "./ScreeningPendingCreatives.vue?vue&type=script&lang=js"
export * from "./ScreeningPendingCreatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports